/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskHealthzDatastores
 */
export interface ExecRiskHealthzDatastores {
    /**
     * 
     * @type {boolean}
     * @memberof ExecRiskHealthzDatastores
     */
    postgres: boolean;
}

/**
 * Check if a given object implements the ExecRiskHealthzDatastores interface.
 */
export function instanceOfExecRiskHealthzDatastores(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "postgres" in value;

    return isInstance;
}

export function ExecRiskHealthzDatastoresFromJSON(json: any): ExecRiskHealthzDatastores {
    return ExecRiskHealthzDatastoresFromJSONTyped(json, false);
}

export function ExecRiskHealthzDatastoresFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskHealthzDatastores {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'postgres': json['postgres'],
    };
}

export function ExecRiskHealthzDatastoresToJSON(value?: ExecRiskHealthzDatastores | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'postgres': value.postgres,
    };
}

